import React from 'react'
import Message from './Message'
import { useAuthenticator } from '@aws-amplify/ui-react';

const VerifyUser = (props) => {
  const { user } = useAuthenticator((context) => [context.user]);
  let error = '';

  if (user && user['attributes']) {
    const count = user['attributes']['custom:ID'];
    if (count < 10) {
      error = 'Das Konto wird in ' + user['attributes']['custom:ID'] + ' Tagen wieder gelöscht.';
    }
    if (count === 1) {
      error = 'Das Konto wird heute noch geprüft.';
    }
  }

  return <Message variant='warning' children={error} />
}

export function verifiedUser(user) {
  if (user && user['attributes'] && user['attributes'].hasOwnProperty('custom:ID')) {
    return user['attributes']['custom:ID'] === '10';
  }
  return false;
}

export function istMitarbeiter(user) {
  const isUser = user && user.attributes;
  return isUser ? user.attributes.hasOwnProperty('custom:kvsID') ? (parseInt(user.attributes['custom:kvsID']) < 10000) : false : false;
}

export function istAdmin(user) {
  const isUser = user && user.attributes;
  return isUser ? user.attributes.hasOwnProperty('custom:kvsID') ? ([1084, 6557, 7997, 1095].includes(parseInt(user.attributes['custom:kvsID']))) : false : false;
}

export default VerifyUser;
